module.exports = __webpack_public_path__ + "static/media/autosign.d3d6ef9d.svg";